import React from 'react';
import PropTypes from 'prop-types';

import { BREAKPOINTS, BREAKPOINT_SIZES } from 'tradera-utils/breakpoints';
import { BasicCarousel } from '../basic';
import { ImageGalleryModal } from 'components/modals/image-gallery-modal/image-gallery-modal';
import ViewItemImage from './view-item-image';
import './view-item-carousel.scss';
import './cursor.scss';

class ViewItemCarouselZoom extends React.Component {
    static propTypes = {
        carouselStyle: PropTypes.object,
        className: PropTypes.string,
        enableZoom: PropTypes.bool,
        fixedHeight: PropTypes.bool,
        images: PropTypes.array.isRequired,
        pageType: PropTypes.string
    };

    static defaultProps = {
        carouselStyle: {},
        className: '',
        enableZoom: false,
        fixedHeight: true
    };

    state = {
        showZoomModal: false,
        activeSlideIndex: 0
    };

    constructor(props) {
        super(props);
        this.basicCarousel = React.createRef();
    }

    render() {
        const {
            carouselStyle,
            className,
            enableZoom,
            fixedHeight,
            images,
            ...rest
        } = this.props;
        const { showZoomModal, activeSlideIndex } = this.state;

        const onMouseUp = () => {
            if (enableZoom) {
                this.setState({
                    showZoomModal: true
                });
            }
        };

        const settings = {
            customPaging: imageIndex => {
                return (
                    <div
                        className="position-relative cursor-pointer"
                        onMouseUp={onMouseUp}
                        onMouseOver={() =>
                            this.basicCarousel.current.goTo(imageIndex)
                        }>
                        <img
                            loading="lazy"
                            className="carousel-thumbnail"
                            width="49px"
                            height="49px"
                            src={images[imageIndex].multiThumbnail}
                        />
                        <div className="carousel-thumbnail--overlay" />
                    </div>
                );
            },
            afterChange: index => {
                this.setState({ activeSlideIndex: index });
            },
            initialSlide: activeSlideIndex,
            accessibility: false,
            responsive: [
                {
                    breakpoint: BREAKPOINT_SIZES[BREAKPOINTS.MD].min,
                    settings: {
                        customPaging: function(i) {
                            return <button>{i}</button>;
                        }
                    }
                }
            ]
        };

        return (
            <div className={className} style={carouselStyle}>
                <BasicCarousel
                    key={images.length} // forces reload when changes
                    ref={this.basicCarousel}
                    className={`view-item--carousel view-item--carousel__bottom-arrows ${
                        !fixedHeight && images.length < 2 ? 'mb-2' : ''
                    }`}
                    settings={settings}
                    {...rest}>
                    {images.map((image, index) => (
                        <ViewItemImage
                            key={index}
                            image={image}
                            enableZoom={enableZoom}
                            handleZoomClick={() => {
                                if (enableZoom) {
                                    this.setState({
                                        showZoomModal: true
                                    });
                                }
                            }}
                        />
                    ))}
                </BasicCarousel>
                {enableZoom && showZoomModal && (
                    <ImageGalleryModal
                        initialSlideIndex={activeSlideIndex}
                        fixedHeight={true}
                        closeModalCallback={() => {
                            this.setState({ showZoomModal: false });
                        }}
                        images={images}
                    />
                )}
            </div>
        );
    }
}

export default ViewItemCarouselZoom;
